export const ADD_TO_CART = "ADD_TO_CART"
export const REMOVE_FROM_CART = "REMOVE_FROM_CART"
export const FETCH_ALL_PRODUCTS = "FETCH_ALL_PRODUCTS"
export const CART_ERROR_MESSAGE = "CART_ERROR_MESSAGE"
